// StandardChip.jsx
import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const capitalizeWords = (text = '') =>
  text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const StandardChip = ({
  label = '',
  selected,
  defaultSelected = false,
  showDelete = false,
  sx = {},
  onChange,
  captalise = true,
  height='24px',
  ...rest
}) => {
  const theme = useTheme();
  const isControlled = selected !== undefined;
  const [internal, setInternal] = useState(defaultSelected);
  const active = isControlled ? selected : internal;

  const brownColor = '#995A00';
  const grayColor = theme.palette.grey[400];
  const blackColor = '#333333';

  const handleToggle = () => {
    if (!isControlled) setInternal(prev => !prev);
    onChange?.(!active);
  };

  return (
    <Chip
      label={captalise ? capitalizeWords(label) : label}
      onClick={handleToggle} // ✅ always toggle
      onDelete={active && showDelete ? handleToggle : undefined}
      deleteIcon={active && showDelete ? <CloseIcon /> : undefined}
      sx={{
        fontWeight: 600,
        fontSize: { xs: '11px', md: '13px' },
        // px: { xs: '0px', sm: '4px' },
        // py: '8px',
        padding: {xs: '4px 4px', sm: '4px 4px'},
        borderRadius: '8px',
        color: active ? brownColor : blackColor,
        backgroundColor: 'transparent',
        border: `1px solid ${active ? brownColor : grayColor}`,
        cursor: 'pointer',
        height: {height},
        ...sx,
      }}
      {...rest}
    />
  );
};

export default StandardChip;
